const initialState = {
  comments: [],
};

const setCommentsReducer = (state = initialState, action: any) => {
  switch (action.type) {
    case "SET_COMMENTS_DATA":
      return {
        ...state,
        comments: action.payload,
      };
    default:
      return state;
  }
};

export default setCommentsReducer;